module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h1', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "c1"
    }
  }), _vm._v("1. SOMETHING WICKED")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-01"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p05-01.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" THE MAGICAL SKULL OF DOOM "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("Very few objects have engendered as much controversy or imaginative conjecture as the Magical Skull of Doom, a crystal skull life size in its circumference and likeness to the human head. Shrouded in mysterious and unknown origins, there are countless tales of strange phenomena associated with it. Some believe it is haunted, others believe it is cursed, and still others believe it is of extraterrestrial origin.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("As legend has it, the skull first turned up in the 1920s under an altar in the archaeological dig of the ruins of Lubaantun, the great Mayan city in what is now known as Belize. Some of the greatest arguments occur over whether or not the Magical Skull of Doom is pre-Columbian. While other crystal skulls have been discovered in Central American ruins, none can match the Skull of Doom for its perfection of craftsmanship and likeness to a real skull. Perhaps the biggest mystery of all is that the crystal from which the skull was carved appears to be derived only from California, not the Mayan territory.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Frederick Mitchell Hedges, one of the archaeologists who was present at the discovery, is rumored to have planted it on the occasion of his adopted daughter Ann's "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("birthday, the day of the skull's discovery. It has also been suggested that the skull was never in Lubaantun. Nevertheless, Hedges proclaimed that the skull was “used by the high priest of the Maya to concentrate on and will death,” that it was “the embodiment of all evil,” or that people who scoffed at the skull have died or “have been stricken and become seriously ill.” Hedges also attributed to the large hunk of crystal the moniker of “the Skull of Doom” and greatly aided in the swirl of rumors, mist, and myth that has continued to enshroud it.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Frank Dortland, a highly reputable art restorer and one of the later owners of the skull, kept and studied the Magical Skull of Doom. Dortland swore that the skull gave off an “elusive perfume,” that it seemed to emanate a sound similar to bells chiming, and that it could change color at will. He also claimed that it sometimes was filled with ever-changing, cloudy images and at other times it contained crystal-clear images of temples, mountains, and myriad other striking scenes. Other folks who observed the skull when it was under Dortland's watch said a hazy aura would occasionally enshroud it. Still stranger are the reports of physiological phenomena, such as a quickening of the pulse, muscle spasms in the legs and arms, and even eye twitching, affecting people who were near the skull.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Maybe people are fascinated with the Magical Skull of Doom because it is simple in its inherent magnificence. It looks like it was formed whole, and it bears nearly no sign of tool marks. The artist who created this skull was a master of the highest order—the handiwork is nothing short of spectacular. Just polishing the skull would have been a labor of some years. The proverbial icing on the cake is especially fascinating: the skull is crafted in such a way that light collects and refracts in the eye sockets, causing them to emit an eerie glow.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-02"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" THE TRANSYLVANIAN TABLETS "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("In 1961 archaeologists digging into a prehistoric mound in the Transylvanian village of Tartaria made a startling discovery—several small clay tablets with bizarre inscriptions on them. Some believed the inscriptions to be sigils or magical signs, and others believed that they were important documents left behind for the singular purpose of being found—time capsules, perhaps. Using the modern method of carbon dating, the objects' origin was placed at around 4000 B.C. The writing was believed to be of Mesopotamian origin, specifically Sumerian, the first written language. Could this discovery mean the origins of writing began in the wild backwoods of Transylvania?")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("The three tablets were found in the lowest layer of the dig. They were in a sacrificial pit within a burial mound, and the pit also contained some scattered human bones. The bones bore symbols quite similar to the inscriptions on the tablets; the symbols were both from Sumer and from the highly advanced Minoan civilizations of Crete. But if the carbon dating is accurate, the tablets were made by a primitive Stone Age agricultural tribe known as the Vinca. The Vinca predated Sumerian writing by one millennium and the Minoan writing by two thousand years. Most scholars believe that the inscriptions were magical ciphers—spells and secret codes of this ancient farming tribe. The hash marks, swirls, "), _c('i', [_vm._v("x")]), _vm._v("'s, and shapes on the three tablets cast a spell over mystery lovers, too.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-03"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" STONEHENGE "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Built over four thousand years ago, Stonehenge, the massive stone monument that sits on the Salisbury Plain of England, is shrouded in mystery and legend. Was it constructed as an ancient calendar and used to predict astrological events or seasonal changes? Or was it a place of worship, a spiritual temple built to honor the deities of its makers?")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("The purpose of this spectacular man-made rock formation has been studied and debated for centuries. Just as bewildering is the question of how Stonehenge was created. Some of the stones used are believed to have come from hundreds of miles away. How were these rocks, some weighing up to four tons, transported such a distance in an era before the invention of the wheel? No one knows for sure.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("And no one knows for sure "), _c('i', [_vm._v("who")]), _vm._v(" built Stonehenge. There are many supernatural and mystical theories, though none have ever been proven. Some believe Stonehenge was the creation of aliens, while others claim that the sorcerer Merlin used his magical powers to move the stones across the land and sea. One legend even tells of the devil creating Stonehenge as part of a bizarre riddle he concocted to toy with local villagers.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-04"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" STONE'S PUBLIC HOUSE "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Numerous stories of ghostly encounters surround Stone's Public House in Ashland, Massachusetts. The inn and pub was built in 1834 by John Stone and still serves as a restaurant and pub today.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The assistant manager of Stone's tells a tale of being alone in the pub one night, finishing up the day's "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("duties, and having a sudden feeling of terror. Then a handful of birdseed fell through holes in the ceiling, rattling to his newly mopped floor. Other staffers report water faucets turning on by themselves, and numerous patrons say they have felt someone tapping on their shoulder only to find no one behind them when they turn around.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("A noted hypnotist and parapsychologist, Ralph Bibbo, visited the inn numerous times and says that there are at least six, possibly seven, different ghosts that dwell there. Bibbo says that Stone himself accidentally killed a boarder in 1845 and tried to cover up the murder. The other spirits were accomplices or witnesses to Stone's crime. Having sworn to keep Stone's crime a secret while they were alive, they are still bound to the pub in death.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-05"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" THE TOWER OF LONDON "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The Tower of London is perhaps the most infamous haunted dwelling in history. Built over a two-hundred-year period beginning in the early eleventh century, the complex is seen as an architectural wonder, having over twenty towers and occupying over eighteen acres of land.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("The Tower of London was used as by English monarchs as a prison, and it has housed some of Britain's most notorious of criminals. Murderers and traitors to the crown were locked up in one of its many towers to await execution, and those prisoners who were sentenced to death were beheaded within the Tower's very walls. Many of those who were beheaded are said to haunt the Tower to this day. Lady Jane Grey, who held the throne for only nine days in 1554 before being executed in the Tower, is said to appear every year on the day of her death, holding her own head beneath her arm.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Two other murdered queens, Anne Boleyn and Katherine Howard, both wives of Henry the VIII, also are said to appear within the Tower as two headless figures surrounded by a supernatural glow. Katherine has even be seen and heard wandering the halls and begging for mercy as she did on the day of her execution.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("One of the Tower's most gruesome murders was of the Countess of Salisbury. As her head was placed on the executioner's block, she panicked and tried to run. The executioner chased her down and hacked her to death with his axe. It is said that the spirits of the countess and her executioner appear and reenact her brutal murder.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Of all the ghostly sightings in the Tower of London, the most disturbing are the apparitions of two small "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("boys walking along the hallways hand in hand. These boys are believed to be the sons and heirs of King Edward V. Edward's brother Richard, the duke of Gloucester, placed his nephews in the Tower after King Edward's death. He later smothered the two princes in their sleep, so that he could claim the king's throne for himself.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“It's fascinating to think that all around us there's an invisible world we can't even see. I'm speaking, of course, of the World of the Invisible Scary Skeletons.” —JACK HANDY")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-06"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" A GHOST TO BE "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("What manner of death creates a ghost? While many ghosts may stay on after their passing because they are fond of a place (or person), most hauntings are attributed to some kind of disruptive death. Leslie Rule describes these as “ghost makers” in her book "), _c('i', [_vm._v("Coast to Coast Ghosts")]), _vm._v(":")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_vm._v("Murder. Unsolved killings especially. Ghost often moves on once the murder is solved.")]), _vm._v(" "), _c('li', [_vm._v("Suicide. Torment equals a soul bound to earth.")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("Accidents. Sudden deaths have more hauntings attached to them than deaths of natural causes.")]), _vm._v(" "), _c('li', [_vm._v("Broken hearts. Those who die mourning are often the source of ghostly activity.")]), _vm._v(" "), _c('li', [_vm._v("Greed. A preoccupation with land or money in life can be carried into the beyond.")]), _vm._v(" "), _c('li', [_vm._v("Lack of proper burial or desecration of grave site.")])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("“FROM THE BODY OF ONE GUILTY DEED A THOUSAND GHOSTLY FEARS AND HAUNTING THOUGHTS PROCEED.” "), _c('span', {
    staticClass: "small"
  }, [_vm._v("—WILLIAM WORDSWORTH")])])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-07"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" KING'S TAVERN, NATCHEZ, MISSISSIPPI "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The story of the ghosts at King's Tavern in Natchez, Mississippi, dates back to the late 1700s, when a woman named Madeline, the mistress of Richard King, was murdered by King's jealous wife. For more than 200 years, the tavern's patrons have reported hauntings, including the ghost of a woman standing in front of them, angrily poised with hands on her hips.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("In the 1930s, the skeleton of a woman was discovered sealed in a brick fireplace, a dagger in her chest.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-08"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" SILAS OF KENNEBUNK "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("The Kennebunk Inn in Kennebunkport, Maine is reputed to be haunted by a friendly ghost named Silas. Among Silas's tricks are levitating glasses and throwing beer mugs.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-09"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" REBECCA DORRINGTON'S FATAL FALL "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("In the High Sierra of California, among the pines and fresh mountain air, the little town of Dorrington is home to the Dorrington Hotel. The town is named after Rebecca Dorrington, who died in a fatal fall down a flight of stairs in the hotel in 1870. Today's hotel guests report banging doors, flashing lights, and furniture shifting. Some have even claimed to witness a phantom re-creation of Rebecca's fatal fall.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-10"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" HAUNTED? A CHECKLIST "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Here are six telltale signs that your house may be haunted, especially if any of the signs occur repeatedly:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_vm._v("Pets react with seemingly out-of-place growls, barks, or hisses to things no one else can see.")]), _vm._v(" "), _c('li', [_vm._v("Household members have repeated nightmares.")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("Objects disappear, often to reappear somewhere else after some time. For example, a young woman living in an old railroad flat in Santa Fe has come home to find her ghost had moved or turned over her sugar bowl on numerous occasions.")]), _vm._v(" "), _c('li', [_vm._v("Electrical appliances turn on or off by themselves. Faucets or toilets run or flush themselves.")]), _vm._v(" "), _c('li', [_vm._v("The building has inexplicable cold drafts or cold spots.")]), _vm._v(" "), _c('li', [_vm._v("Inhabitants hear footsteps, taps on walls or windows, and voices that cannot be attributed to other living people or sources in the house.")])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("“WHERE'ER WE TREAD ’TIS HAUNTED, HOLY GROUND.” "), _c('span', {
    staticClass: "small"
  }, [_vm._v("—LORD BYRON")])])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-11"
    }
  }), _vm._v("NEW ENGLAND GHOST")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U007.jpg"
    }
  }), _vm._v(" AS TOLD BY RAYMOND BUCKLAND "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U008.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("I first came to the United States in 1962. I lived on Long Island, New York, and then, about ten years later, moved up to live on the shores of Lake Winnepesaukee, New Hampshire. My wife and I purchased a house there, at Weirs Beach.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("The house was built circa 1825. It was a beautiful two-story with an attached ell barn, stable, and outbuildings, set on a couple of acres. Right from the start we felt very comfortable and very welcomed in the house. It had a very large living room with a wonderful beamed ceiling. The room ran the length of the house on the west side. A staircase went up the center of the house; the front door was at its base, and there were four bedrooms above. On the east side of the house was the kitchen and my study. My study had two windows looking out to the front and one looking to the side. A later addition was a screened-in porch that ran across the full front of the house. The door at the east end of this porch opened onto a paved path leading to the garage and the driveway.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("We quickly came to realize that the house was haunted. While we sat downstairs in the living room, we frequently heard footsteps walking about in the bedrooms. I particularly remember one time when the footsteps walked across the room above (my elder son's front bedroom) and then started down the stairs. My wife and I were sitting in the living room, and we both turned to see who had come down, since neither of my sons was home; we expected the person to come around the corner from the foot of the stairs into the living "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("room. But no one came. The footsteps had stopped at the bottom of the stairs. I got up out of my chair and went to look. There was no one there;the staircase was empty.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("On another occasion my wife's grandmother was staying with us, sleeping in my elder son's bedroom. One morning she came down to breakfast and reported a nighttime visitor. She said that she had awakened in the middle of the night to find a woman standing at the foot of her bed. There was a night-light in the room, and she could see that the woman was wearing a long blue dress. The figure studied her for a few moments and then turned and simply disappeared, fading away to nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("I saw a figure myself, once. I was in my study when I heard the screen door bang and looked up to glimpse a man crossing the porch to go to the front door. As I got up from my desk, I expected to hear the front doorbell ring, but it didn't. I went and opened the door and looked out. There was no one there. The porch was empty. There was no one outside or anywhere in the driveway. The screen door invariably squeaked when opened, but I didn't hear it squeak on this occasion.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("We lived in the house for almost five years and became accustomed to our ghosts. They were in no way malevolent. We were sorry to say good-bye to them when we eventually sold the house and moved away.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("“Nothing beats a haunted moonlit night on All Hallows Eve. . . And on this fatal night, at this witching time, the starless sky laments black and unmoving. The somber hues of an ominous, dark forest are suddenly illuminated under the emerging face of the full moon.” —KIM ELIZABETH")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-12"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" NOT ALL HAUNTS ARE OLD "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Brad Steiger's "), _c('i', [_vm._v("Real Ghosts, Restless Spirits, and Haunted Places")]), _vm._v(" is chock full of fantastically frightening true tales of terror. Among them is the story of a woman and her husband who moved into a house in 1992, when the house was just eleven years old. Not long after moving in, the woman began to hear someone walking in her upstairs hallway. Convinced it was her son sneaking out, she would go upstairs to check on him and find him sleeping soundly in bed. At first, she did not speak of the footsteps, not even to her husband and son. Then the footsteps increased in frequency and changed location, including coming into her bedroom. It didn't take her long to learn from her husband that he, too, was hearing many strange noises, particularly when he was home alone during the brightness of day. In the first month of "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("living there, she told author Steiger that they went through at least one hundred lightbulbs; lights were constantly blowing out all throughout the house.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The woman said the noises had begun just after the family had moved in—when she'd hung an old lead mirror, left behind by the previous owners, in the hallway opposite her son's room. Only when she got rid of the mirror did the noises stop.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p19-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-13"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" ANIMAL APPARITIONS "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Not only do animals sense ghosts, but animals also can be ghosts. For example:")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style-image": "url(images/U009.jpg)"
    }
  }, [_c('li', [_vm._v("Actor Rudolph Valentino's Great Dane, Kabar, is reported to haunt his former owner's gravesite.")]), _vm._v(" "), _c('li', [_vm._v("In Port Tabacco, Maryland, there is a bloodstained rock known to locals as Peddler's Rock. It is said to be home to the Blue Dog, who guards his dead master's buried treasure.")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("In Casper, Wyoming, ranchers have long reported the image of a white steed galloping across the area known as Rattlesnake Range. This horse was known as White Devil when he was alive, due to his reputation for fiercely defending himself and other horses against the mighty lasso.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("In Reading, Pennsylvania, the ghosts of Mrs. Bissinger and her children still roam an area near the Union Lock Canal where she drowned herself (and her children) in 1875. Visitors to this area often report being overwhelmed by a sad and horrific energy.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-14"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" A FOND FAREWELL "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Dana was the youngest of four kids, living in an old Victorian house in the Minnesota suburbs. Her grandfather, who lived in the same town as she did, was sick in the hospital, but Dana was too young to really know what was going on or that he was dying. One day while her mother was at the hospital, Dana came walking down the grand staircase in her house. To her surprise, she saw her grandfather walking up toward her, looking "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("healthy and happy. “I wanted to say good-bye, Dana, and I love you very much,” he said and continued up the stairs. Delighted, the child raced into the kitchen to tell her mother that Grandpa was all better and that he'd come over for a visit. But her mother had just returned from the hospital with some bad news—her grandfather had passed away earlier that afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Have you seen a ghost? It is possible that you have and just didn't know what to look for. If the figure you saw was unusually pale, disappeared after an instant, ignored you when you spoke or called out, appeared in an odd place, or was dressed inappropriately (often of another era), perhaps you have seen a ghost. (Of course, many of these characteristics could describe some of your relatives as well.)")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-15"
    }
  }), _vm._v("THE HAUNTED BOAT HOUSE")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U007.jpg"
    }
  }), _vm._v(" AS TOLD BY CHRIS WARD "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U008.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("It was late October 2004, and as part of a unique archaeological project along the Drakes Bay bluff on the Point Reyes National Seashore in Northern California, "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("our five-person team was given accommodation at the restored Drakes Bay Lifesaving Station, otherwise known as the Boat House.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The Boat House, a National Historic Landmark, is an impressive building overlooking the waters of Drakes Bay. As the park official led us on our initial tour of the building, I could not help but notice a creeping feeling that seemed to hang around. These sensations increased when we were brought into the Boat Room. The Boat Room houses a now-decommissioned lifeboat, the first motorized lifeboat north of San Francisco Bay. The lifeboat had been used in countless rescue missions from 1953 to 1965, covering the extent of the Northern California coastline from Drakes Bay north to Humboldt Bay. I had to wonder why such a unique historic relic was shut away in this room. It was resting half on the ground, half off, teetering on an old wooden sawhorse. When I inquired, the park official responded with this story.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("On a stormy Thanksgiving eve in 1960, the Coast Guard team at Drakes Bay was alerted to a cry for help from a fishing boat that appeared to be in distress north of Fort Bragg. A well-trained and competent crew, they quickly responded. A two-person crew launched the lifeboat into the dark night (no easy task) and headed "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("north to Fort Bragg through blinding rain and turbulent seas. The experienced seamen made their way up the rocky and treacherous coast and successfully towed the fishing boat to shore just outside of Fort Bragg. They then reportedly headed south to Drakes Bay. The crew members never returned to the Boat House.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The following morning a search party headed to the Boat House, only to discover a horrific sight. The lifeboat had run aground not more than 150 yards from its berth at the Boat House. The engine and propeller were still churning. Yet neither member of the crew was in sight. Although the lifeboat had traveled hundreds of miles in the most adverse of conditions and had returned to the very bay from whence it had launched, there was no sign of either seaman. Their bodies were never found. Shortly thereafter, the Boat House was decommissioned and the lifeboat locked away.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("For some twenty years, the lifeboat sat in its home, until the National Park Service created the Point Reyes National Seashore, and the historic Boat House and lifeboat therein became part of a lengthy restoration process. The park service restored the lifeboat to its former glory, intending to take it back out into the bay for special occasions. At last the day came for the boat to be launched again into the salty waters. Reporters "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("and park supporters gathered round to view the lifeboat, which was supported on a carriage of two wooden sawhorses. Just at the moment of rechristening, the lifeboat lurched forward and crashed down, smashing one of the sawhorses and damaging the keel of the boat extensively. The boat would not again touch the waters of Drakes Bay, and it remains exactly where it fell, half on and half off the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("For four nights in late October, after long days of archaeological work, our five-person crew returned to the Boat House for a night's sleep. Yet these nights were anything but restful. Each member of our crew reported strange happenings and unexplained sounds. Mysterious footsteps creaked down the corridor outside the Captain's Room, when all members of our team were accounted for. Things slammed to the floor in the Boat Room—things that had been fastened tightly to the wall the night before. One of our crew members repeatedly said that there was somebody looking through the shelves in the kitchen, where she saw shadows. This sight was enough to scare her from her luxurious room downstairs to the bunks upstairs where the rest of us lodged.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("A lunar eclipse, the shortened days and long nights of late October, a brewing storm, a boat house that rests "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("three-quarters of the way over the murky waters of the bay—even a team of rational scientists could not help but feel that there was something decidedly haunted about the Boat House.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“It is an odd thing, but every one who disappears is said to be seen in San Francisco. It must be a delightful city, and possess all the attractions of the next world.” —OSCAR WILDE")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-16"
    }
  }), _vm._v("BIZARRE HAPPENINGS IN PORTLAND")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U007.jpg"
    }
  }), _vm._v(" AS TOLD BY ALIX BENEDICT "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U008.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("A friend of mine had purchased a house in Portland, Oregon, and was just completing a rather extensive renovation. One of the men who was working on the house was also staying there, despite the raw conditions. Throughout the period of time he was living there, he had numerous strange experiences. Doors slammed and then creaked open, and he had a constant feeling of being watched. The wires that had been rigged into light sockets and outlets were ripped clean, over and over. Painters reported open cans of "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("paint had been turned upside down without a drop spilled, only for paint to go all over the floor when they attempted to move the can. My friend, the owner, had purchased a set of spiral stairs from an auction. The metal stairs had once been in the local jailhouse and were used by prisoners. Later, the man living in the house said that nothing happened until after they had installed the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("When the renovation was nearly complete, I was hired to clean up and put the finishing touches on the place. One evening, I was at the house, working late. The owner was upstairs asleep, and I was in the basement with my headphones on. It was pretty late, at least 10 or 11 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")]), _vm._v(" I had repeatedly felt something like a crawling sensation in my hair, but attributed it to spiders or dust, as the house was still in a bit of disarray. But then I felt and saw something that I knew was no spider! I was working in front of a bank of windows, cleaning them and scraping away the paint that had gotten on to the glass. As it was light inside but dark outside, the windows were a bit like a mirror. I felt something like a tug on a piece of my hair, and I looked at my reflection in the window. I actually saw a piece of my hair move up and away from my head, as if someone were standing behind me and pulling at it. I was dumbstruck and actually "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("froze with shock. I stood there for what felt like several minutes, but was probably just a few seconds, and then promptly bolted upstairs and woke up the owner. I have lived in a few haunted places, but watching my hair move of its own accord was decidedly unnerving.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The owner and I did some historical research on the place and discovered that two people had died there in the past. One was a little old lady, who died of natural causes. The other was a local sheriff, who shot and killed himself in the house. We all came to suspect he was our ghost, especially because the stairs from the county jail seemed to trigger the start of all of the spooky and strange activity.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p27-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“Then away out in the woods I heard that kind of a sound that a ghost makes when it wants to tell about something that's on its mind and can't make itself understood, and so can't rest easy in its grave, and has to go about that way every night grieving.” —MARK TWAIN")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-17"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p28-01.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" THE FLYING DUTCHMAN "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("A seventeenth-century Dutch merchant vessel, "), _c('i', [_vm._v("The Flying Dutchman")]), _vm._v(", and her phantoms are legendary. The ship ran into trouble around the dangerous Cape of Good Hope in South Africa. Accounts of what exactly happened vary: some say Captain Hendrick van der Decken refused to seek shelter in the harbor, others say it was impossible to do so because of the weather. Regardless, "), _c('i', [_vm._v("The Flying Dutchman")]), _vm._v(" sank, but it hardly disappeared. Since the 1800s there have been sightings of a phantom ship that will sometimes pull alongside other ships, but the ghost ship is most often seen from the lighthouse point. Among the witnesses over the years were England's King George V and several famous authors.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-18"
    }
  }), _vm._v("THE GHOSTS OF NEVADA COUNTY, CALIFORNIA")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U007.jpg"
    }
  }), _vm._v(" A LITTLE HAUNTED HOTEL ON THE CORNER "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U008.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("In the historic town of Nevada City, California, high in the Sierra foothills, on the corner of Broad and Pine streets, there is a small hotel with a big history. Owner Katie Bennett, who bought the US Hotel in 2002, has heard strange noises and mysterious sounds regularly.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("And so have her patrons. The odd occurrences include knocking noises, steps that sound like someone is right outside your door, and lights that flicker on and off. The most common thing Bennett hears is laughter, accompanied by music and footsteps as if someone is dancing. So it was no surprise to her when a team of paranormal investigators caught the sound of laughter and footsteps on tape. The recordings included a man calling out for someone named Olga, the sound of boots on hardwood floors, and popping and knocking noises. Visit "), _c('a', {
    attrs: {
      "href": "http://www.norcalghosthunters.com",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("www.norcalghosthunters.com")])]), _vm._v(", click on EVPs (electronic voice phenomena) and links, and then scroll down to “US Hotel B&B EVP Link” to hear the evidence for yourself.")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle3"
  }, [_c('a', {
    attrs: {
      "id": "c01-19"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U007.jpg"
    }
  }), _vm._v(" A GHOSTLY IMAGE "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U008.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("In January of 2007 "), _c('i', [_vm._v("The Union")]), _vm._v(", the local paper for Nevada County, California, reported that a ghostly face had appeared in a photograph. The photo had been taken of the historic Skidmore House, one of a dozen or so original homes still standing in North Bloomfield, a mining town that is now part of the Malakoff Diggins State Historic Park. Sonny Lopez, the park's maintenance mechanic, had moved to the park in July of 2006. He and his wife wanted window treatments that had an old-time feel, and so one afternoon Lopez took several "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("photographs of Skidmore House and its windows. Later, when he went home to show the photos to his wife, he noticed that the otherwise empty home was perhaps not so empty. In one of the photos was a figure that looked like a woman with long hair, pulling back the curtain and looking back out at him. You can view the photograph yourself in "), _c('i', [_vm._v("The Union")]), _vm._v("'s online archives at "), _c('a', {
    attrs: {
      "href": "http://www.theunion.com",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("www.theunion.com")])]), _vm._v(". Do a search for “ghostly photographs” and see what appears.")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle3"
  }, [_c('a', {
    attrs: {
      "id": "c01-20"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U007.jpg"
    }
  }), _vm._v(" THE GHOST IN THE FLAME "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U008.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Originally built as a firehouse, a necessary building in a gold-rush town of shacks and temporary structures, the Fire House No. 2 in Nevada City, California, is now a historical museum. Visitors and employees alike have reported hearing footsteps in an otherwise empty room, as well as feeling sudden temperature changes, cold spots, and a general “thickening” of the atmosphere. Some witnesses claim to have seen the ghost of a Victorian woman, who searches through cabinets, and a female piano player from a nearby whorehouse. A few visitors have even sighted a group of Chinese men standing around a shrine, a testimony to the Chinese population that contributed to Nevada City's early growth.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p31-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-21"
    }
  }), _vm._v("A PARALYZING NIGHT")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U007.jpg"
    }
  }), _vm._v(" AS TOLD BY GIOVANNI GALATI "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U008.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("In the mid-1980s in Hanover, Germany, my family owned a large apartment house where my parents, brothers, I, and other employees of the restaurant my father owned would rent rooms. Many of the residents reported ghostly sightings and encounters. Some employees refused to stay. But I was the skeptic—until one night.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("I arrived home late after work, close to one in the morning, and fell fast asleep. A few hours later, probably around four or five, I awoke suddenly, my eyes wide open. At this moment, I heard the key turn in the lock to my front door. Instinctively, I tried to get up to see who it could be. I lived alone and thought I had the only key to the apartment. But I was completely paralyzed. I could not move—not my fingers, my toes, nor even my head—to see who could be there.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("As I lay there struggling with the inability to move, I heard footsteps go through the hall and into the kitchen, echoing across the wooden floors. I then heard the handle of my bedroom door begin to turn. I could hear someone or something come in the door and stand "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("next to my bed, looming over me. Yet I could not turn my head to see who or what was there. At this point tears were streaming down my face, not as much from being frightened as from being completely frustrated at my inability to so much as wiggle my fingers. I tried everything I could, using reason to try and send the signals to my brain to move my body. After a bit of time—maybe ten or fifteen minutes, though I can't say for sure—I felt the presence withdraw. I heard footsteps move away from my bed toward the door, the sound of the door handle turn, the door open and close, and then the echo of the footsteps retreat back through the kitchen, down the hall, and out the front door of my apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("As soon as the front door closed, I was able to move. I jumped up, grabbed the key, and ran out of the bedroom. I could still hear the footsteps descending the inner stairwell, as I lunged toward the apartment door. I heard the outside door of the building slam shut, and I ran down the stairs and out the main door. I couldn't see anyone, so I ran down the path and looked right and left down the street. There was no one in sight. A fresh snow had fallen while I was asleep, and I could see no mark or footprint of where anyone had been on the path or the porch.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-22"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" THE PALACE OF VERSAILLES "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("Just outside of Paris, France, among the rambling and vast grounds of the Palace of Versailles, stands Le Petit Trianon. Best known for being the residence of Marie Antoinette, Le Petit Trianon was given her name by King Louis XVI in 1774. Yet this mini palace within a palace is also famous for something else: hauntings.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Over the centuries guests and visitors have reported numerous sightings and unusual sounds. Most often workers in eighteenth-century clothing are seen milling about, and some people claim to have seen the ghost of Marie Antoinette herself. One of the strangest reports is of seeing phantom woodlands and houses that have not been there for more than two hundred years.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-23"
    }
  }), _vm._v("A FITFUL NIGHT IN BARCELONA")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U007.jpg"
    }
  }), _vm._v(" AS TOLD BY K. R. P. "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U008.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("After weeks of traveling, I found myself in a small, dark room just off the main "), _c('i', [_vm._v("La Rambla")]), _vm._v(" in Barcelona, Spain. My girlfriend and I were very weary and grateful for the simple and affordable room. While my girlfriend slipped easily into a deep slumber, I tossed and turned, unable to fall asleep. I became keenly aware of "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("a glowing sensation by and around the shuttered window. Irritated, I tried to ignore it, exhausted as I was. But I was unable to ignore it, and so I looked back toward the window. I clearly saw a man sitting with his back to me, at a desk in front of the window. (There was no actual desk in the room.) He appeared to be leaning forward, writing something down on paper. He took no notice of me whatsoever, and I felt no threat. I simply turned over and, at last, fell asleep.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p34-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1pc"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-24"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" THE HOLY GRAIL "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("This infamous object has been sought by scholars, scientists, and the devout for centuries. The Holy Grail is best known as the cup that Jesus used to drink from at the Last Supper, and that Jesus' uncle used to catch drops of Jesus' blood at the crucifixion. In order to escape persecution, the disciples of Jesus took the Grail to Glastonbury, England. There are countless legends surrounded the Grail and its mystical powers. Some believe it is a cauldron of magic, containing secrets of birth and death. Others argue that the Grail is not an "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("object at all, but rather a state of spiritual enlightenment. Many chalices resting in museums around the world claim to be the actual Grail.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-25"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" SACSAYHUAMAN "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Locals help tourists remember the name of these ancient Inca ruins by laughingly telling them it is pronounced “sexy woman.” On a hillside just above the town of Cuzco, Peru, the Sacsayhuaman ruins still bake in the golden light of the Inca's beloved sun. Most local history says that Cuzco was built in the shape of the sacred puma and Sacsayhuaman was the puma's head. The stone walls and monoliths of Sacsayhuaman were so expertly crafted that the Spanish conquistadores, convinced no mortal man could create stonework so perfect, thought the Sacsayhuaman must have been built by evil spirits.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-26"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" A DAUGHTER'S LOVE "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("November of 1919 was an especially cold and difficult winter in the northern regions of Italy. Snow fell on Venice, and Dr. Antonio Salvatici was making his way down one of the canals in a covered gondola. The "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("doctor was the bishop's personal physician and was leaving the church late after attending to an elderly member of the diocese.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("From the banks of the canals, Dr. Salvatici heard the voice of a young girl crying for help. When the doctor looked through the falling snow to the street, he saw a little girl, clutching a shawl for warmth, calling to him. Her mother was ill, and the little girl was begging that he come tend to her.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Although he was surprised that the girl recognized him as a doctor, he nonetheless answered her plea and disembarked from the gondola, following the little girl to a court, then up a flight of stairs in one of the old houses. There he found a sick woman, who had a terrible case of pneumonia. As Salvatici attempted to ease the woman's pain, he said to her that she was lucky to have such a daughter, one who would brave the elements to come and find him to get her mother help.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("At this the woman looked quite shocked, and reported to the doctor that her daughter had died one month before. Salvatici argued with her, telling the sick woman he had just seen her and followed her here. How else would he have known to go to her, just as she was at her sickest?")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("But the woman insisted her daughter had died and pointed to a cupboard where she kept her daughter's "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("things. The doctor indulged the woman and opened the cabinet, only to discover the woman indeed had her young daughter's things—among them the very shawl, dry as a bone, that he had seen her clutching as she called to him in the snowy night. No trace of the little girl was found.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-27"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" A MEMPHIS BELLE "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The jewel of downtown Memphis, Tennessee, is the Orpheum Theater, a beautiful and ornate theater that hosts classic and modern acts ranging from musicals to Shakespeare to Tom Waits. The Orpheum has also been host to several supernatural events. Most common is the sighting of the ghost of a little girl. Many employees, docents, and historians agree that she is likely the spirit of a little girl who was killed around the turn of the twentieth century by a horse and carriage while crossing the street on her way to the theater. Other accounts say that a girl died when she fell from the upper balcony. While her cause of death is uncertain, there have been multiple sightings of the same little girl, who is known simply as Mary. She is spotted occasionally in the box seats and frequently in the theater before or after a concert or play.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-28"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" THE SILVER QUEEN HOTEL "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("In Virginia City, Nevada, there is a hotel that has stood the test of time. First built in 1876, the Silver Queen Hotel still does not have phones, televisions, or alarm clocks in any of its twenty-nine rooms. Popular among history buffs and those who come to Virginia City to vacation and gamble, the Silver Queen has been host to countless wedding parties, anniversaries, and romance seekers. It also plays host to a few ghost hunters, for it is known for a high level of paranormal activity. While some people come specifically seeking ghosts, other, unsuspecting guests have been shocked to witness haunting activities.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("One couple heard the sound of a banjo being tuned in the room next door, only to find the room empty when they went to investigate. The couple also heard an argument going on outside their door. When they flung open the door, they saw no one, but they still heard two voices arguing. The couple became convinced the hotel was haunted. They were later awakened by a loud pounding at their door, but when they answered, they found only the empty hall.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Other guests have reported hearing creaks, footsteps, and doors opening and closing.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-29"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" TO MARKET, TO MARKET "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("Pike Place Market in Seattle, Washington, is a wellknown attraction in the city's bustling downtown. Apart from a rich history and stalls overflowing with wares, the Market is also home to several legendary ghosts—an elderly Native American woman, a little boy, a large woman, and a tall African-American man. Shopkeepers and tourists alike have reported strange goings-on throughout the years, including sightings of these spirits, footsteps in empty aisles, and items out of place.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-30"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U004.jpg"
    }
  }), _vm._v(" ORIGINS OF THE OUIJA "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The Ouija is any surface printed with letters, numbers, and other symbols and used as a tool to communicate with the dead. The Ouija Board, which was patented by the Parker Brothers in 1920, is what most commonly comes to mind when thinking of the Ouija. The word “ouija” is believed to stem from “oui,” meaning “yes” in French, and “ja” meaning “yes” in Scandinavian languages and in German. Other stories say that the name of the tool was revealed to inventor Charles Kennard during a séance and that “ouija” is actually an Ancient Egyptian word meaning “good luck.”")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("Dominoes originated in Asia around A.D. 1100. They were, and still are, used as a divinatory tool and not just a game of numbers.")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c01-31"
    }
  }), _vm._v("A WEDDING NIGHT VISITOR")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U007.jpg"
    }
  }), _vm._v(" AS TOLD BY K. R. P. "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U008.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("It was the night before my fiancée and I were to be wed. We had chosen a beautiful B&B, the Willard Street Inn, in Burlington, Vermont, for lodging and holding the intimate ceremony. Upon arrival, we were given the run of the place and told we could choose any room we wanted. My wife-to-be and I chose the Tower Room, primarily for its view of Lake Champlain.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("I slept fitfully, tossing and turning until I fell into an exhausted slumber. I hadn't been asleep long when I awoke quite suddenly and sat up. In front of me was a man in his fifties, wearing a tuxedo. He appeared to be trying to make a bed that would have been perpendicular to the bed we were in. He took no notice of me but continued with what seemed to be his normal rounds. I did not feel any threat, and, quite tired, I rolled over and went back to sleep.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d777dece","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_chapter01.vue
// module id = 69
// module chunks = 0